const airgapIntegration = {
  read: () => {
    let isTargetingEnabled = false;
    if (typeof window !== "undefined" && typeof window.airgap !== "undefined" && typeof window.airgap.isConsented === "function") {
      isTargetingEnabled = window.airgap.isConsented(
        /* @__PURE__ */ new Set(["SaleOfInfo"])
      );
    } else {
      console.error(
        "The window object, window.airgap or window.airgap.isConsented is undefined"
      );
    }
    return {
      isTargetingEnabled
    };
  }
};
export {
  airgapIntegration
};
